import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ChartAccounts, ChartAccountsCategoryEnum, ChartAccountsCollection,
  ChartAccountsForm,
  ChartAccountsMessagesEnum,
  ChartAccountsService,
} from 'taxtank-core';
import { BaseFormComponent } from '@shared/component/base/base-form.component';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-chart-accounts-form',
  templateUrl: './chart-accounts-form.component.html',
  styleUrls: ['./chart-accounts-form.component.scss'],
  standalone: false
})
export class ChartAccountsFormComponent extends BaseFormComponent implements OnInit {
  @Input() category: ChartAccountsCategoryEnum;
  @Input() categoryLabel: string;
  form: ChartAccountsForm;
  chartAccountsCategories = ChartAccountsCategoryEnum;
  chartAccountsList: ChartAccountsCollection;
  selectedChartAccounts: ChartAccounts;
  messages = ChartAccountsMessagesEnum;
  @ViewChild(FormGroupDirective) formDirective: FormGroupDirective;
  isLoaded = false;

  constructor(private chartAccountsService: ChartAccountsService) {
    super();
  }

  ngOnInit(): void {
    this.chartAccountsService.get().subscribe(chartAccounts => {
      this.chartAccountsList = chartAccounts.getManual();
      if (this.category) {
        this.chartAccountsList = this.chartAccountsList.filterBy('category', this.category);
      }

      this.isLoaded = true;
    });

    super.ngOnInit();
  }

  buildForm(): void {
    this.form = new ChartAccountsForm(this.selectedChartAccounts);
    if (this.category && !this.selectedChartAccounts) {
      this.form.get('category').patchValue(this.category);
      this.form.addDepreciationGroup();
    }
  }

  save(formValue: ChartAccounts): void {
    if (formValue.id) {
      this.chartAccountsService.put(formValue).subscribe(() => {
        this.toastService.success(this.messages.UPDATED);
        this.reset();
      });
    } else {
      this.chartAccountsService.post(formValue).subscribe(() => {
        this.toastService.success(this.messages.UPDATED);
        this.reset();
      });
    }
  }

  delete(chartAccounts: ChartAccounts): void {
    this.chartAccountsService.delete(chartAccounts).subscribe(() => {
      this.toastService.success(this.messages.DELETED);
    }, (error: HttpErrorResponse) => {
      this.toastService.error(this.messages.DELETE_ERROR);
    });
  }

  toggle(chartAccounts: ChartAccounts): void {
    this.selectedChartAccounts = this.selectedChartAccounts?.id === chartAccounts.id ? undefined : chartAccounts;
    this.buildForm();
  }

  reset(): void {
    this.selectedChartAccounts = undefined;
    this.buildForm();
    this.formDirective.resetForm();
  }
}
